// extracted by mini-css-extract-plugin
export var body = "_3g-1";
export var bodyPadded = "_3g-2";
export var chevron = "_3g-4";
export var chevronOpen = "_3g-5";
export var header = "_3g-0";
export var icon = "_3g-3";